import React from 'react'
import Cards from "./Cards.jsx"

export default function AboutMe() {
  return (
    <section className='about-me' id='About'>
      <Cards></Cards>
    </section>
  )
}
